import AIRequester from '@cobliteam/api-lib/src/dashboard/ai/AIRequester';
import Environment from '@cobliteam/react-environments';
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import type { FileS3Data } from '../types';

const FILES_QUERY_KEY = ['AI', 'FILES'];
/**
 * Get files by their IDs
 * @param threadId - Thread ID to fetch files for
 * @param options - Optional react-query options
 * @returns The files data
 */
export const useThreadFiles = (threadId: string, options?: Partial<UseQueryOptions<FileS3Data>>) => {
  return useQuery<FileS3Data>({
    queryKey: [...FILES_QUERY_KEY, threadId],
    queryFn: async () => {
      const env = Environment.getInstance().getEnvironment();
      const aiRequester = new AIRequester({ host: env.mastraApi });
      const files = await aiRequester.getThreadFiles(threadId);
      return { success: true, status: 'success', data: files.data };
    },
    retry: false,
    ...options,
  });
};
